jQuery(document).ready(function(){

//   var swiper = new Swiper(".logos-listss", {
//     slidesPerView: 2,
//     autoplay: {
//       delay: 2500,
//       disableOnInteraction: false,
//     },
//     loop: true,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     pagination: {
//       el: ".swiper-pagination",
//     },
//     breakpoints: {       
//       320: {       
//         slidesPerView: 2,
//         spaceBetween: 10     
//       },          
//       770: {       
//         slidesPerView: 2,       
//         spaceBetween: 30     
//       },   

//       771: {       
//         slidesPerView: 8,       
//         spaceBetween: 30     
//       } 
//     } 
//   });

});





